import { render, staticRenderFns } from "./FilesCreate.vue?vue&type=template&id=435ccab6"
import script from "./FilesCreate.vue?vue&type=script&lang=ts"
export * from "./FilesCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports